const sassModule = {
  "breakpoints-mobile_portrait": "576",
  "breakpoints-mobile_landscape": "768",
  "breakpoints-tablet": "992",
  "color-flash-brand-coral": "#ff555e",
  "color-flash-brand-yellow": "#ffdf2b",
  "color-flash-brand-orange": "#ff8f3b",
  "color-flash-brand-blue": "#3257c9",
  "color-flash-brand-teal": "#00a0b9",
  "color-flash-brand-cream": "#ffeeea",
  "color-flash-brand-charcoal": "#2e2e2d",
  "color-flash-core-neutral-00": "#ffffff",
  "color-flash-core-neutral-05": "#f7f7f7",
  "color-flash-core-neutral-10": "#e6e6e6",
  "color-flash-core-neutral-20": "#d1d1d1",
  "color-flash-core-neutral-30": "#aeafb2",
  "color-flash-core-neutral-40": "#8c8c8c",
  "color-flash-core-neutral-50": "#606062",
  "color-flash-core-neutral-60": "#424243",
  "color-flash-core-neutral-70": "#2e2e2d",
  "color-flash-core-neutral-80": "#121212",
  "color-flash-core-red-00": "#fff5f8",
  "color-flash-core-red-10": "#ffe0e8",
  "color-flash-core-red-20": "#ffbdc8",
  "color-flash-core-red-30": "#f88d9e",
  "color-flash-core-red-40": "#e04a62",
  "color-flash-core-red-50": "#bf132f",
  "color-flash-core-red-60": "#950019",
  "color-flash-core-red-70": "#680011",
  "color-flash-core-red-80": "#3d000a",
  "color-flash-core-coral-00": "#ffeeeb",
  "color-flash-core-coral-10": "#facdcc",
  "color-flash-core-coral-20": "#f7abab",
  "color-flash-core-coral-30": "#ef8087",
  "color-flash-core-coral-40": "#f0515c",
  "color-flash-core-coral-50": "#b03034",
  "color-flash-core-coral-60": "#8b191f",
  "color-flash-core-coral-70": "#63090e",
  "color-flash-core-coral-80": "#3d0004",
  "color-flash-core-orange-00": "#fff3eb",
  "color-flash-core-orange-10": "#ffdaad",
  "color-flash-core-orange-20": "#ffbc75",
  "color-flash-core-orange-30": "#ff913d",
  "color-flash-core-orange-40": "#e95c20",
  "color-flash-core-orange-50": "#bd3c00",
  "color-flash-core-orange-60": "#8e230b",
  "color-flash-core-orange-70": "#681808",
  "color-flash-core-orange-80": "#43110a",
  "color-flash-core-yellow-00": "#fff8db",
  "color-flash-core-yellow-10": "#ffe5a3",
  "color-flash-core-yellow-20": "#fbcd5b",
  "color-flash-core-yellow-30": "#e2a22c",
  "color-flash-core-yellow-40": "#bc7d24",
  "color-flash-core-yellow-50": "#9e6100",
  "color-flash-core-yellow-60": "#7b4804",
  "color-flash-core-yellow-70": "#5c3200",
  "color-flash-core-yellow-80": "#3b2002",
  "color-flash-core-green-00": "#dffbe4",
  "color-flash-core-green-10": "#a7f1c1",
  "color-flash-core-green-20": "#5adda2",
  "color-flash-core-green-30": "#00c288",
  "color-flash-core-green-40": "#00a375",
  "color-flash-core-green-50": "#007a58",
  "color-flash-core-green-60": "#015035",
  "color-flash-core-green-70": "#073c26",
  "color-flash-core-green-80": "#0d261d",
  "color-flash-core-teal-00": "#e5f9fa",
  "color-flash-core-teal-10": "#a2f5fb",
  "color-flash-core-teal-20": "#67e1e9",
  "color-flash-core-teal-30": "#45d1de",
  "color-flash-core-teal-40": "#009bb2",
  "color-flash-core-teal-50": "#097186",
  "color-flash-core-teal-60": "#0d4b59",
  "color-flash-core-teal-70": "#0f343e",
  "color-flash-core-teal-80": "#0d2126",
  "color-flash-core-blue-00": "#ebefff",
  "color-flash-core-blue-10": "#d4dcfc",
  "color-flash-core-blue-20": "#b1bff6",
  "color-flash-core-blue-30": "#8c9ee8",
  "color-flash-core-blue-40": "#617de0",
  "color-flash-core-blue-50": "#3257c8",
  "color-flash-core-blue-60": "#1c34ba",
  "color-flash-core-blue-70": "#0d1477",
  "color-flash-core-blue-80": "#0a0c3d",
  "color-flash-core-purple-00": "#f3f0ff",
  "color-flash-core-purple-10": "#d4c7ff",
  "color-flash-core-purple-20": "#b49bff",
  "color-flash-core-purple-30": "#9b7aff",
  "color-flash-core-purple-40": "#815af0",
  "color-flash-core-purple-50": "#643cc7",
  "color-flash-core-purple-60": "#513790",
  "color-flash-core-purple-70": "#342754",
  "color-flash-core-purple-80": "#120d1f",
  "color-flash-semantic-text-primary": "#121212",
  "color-flash-semantic-text-secondary": "#424243",
  "color-flash-semantic-text-tertiary": "#8c8c8c",
  "color-flash-semantic-text-critical": "#bf132f",
  "color-flash-semantic-text-warning": "#9e6100",
  "color-flash-semantic-text-success": "#007a58",
  "color-flash-semantic-text-info": "#3257c8",
  "color-flash-semantic-text-highlight": "#097186",
  "color-flash-semantic-text-interactive": "#3257c8",
  "color-flash-semantic-text-interactive_hovered": "#1c34ba",
  "color-flash-semantic-text-interactive_pressed": "#0d1477",
  "color-flash-semantic-text-inverse_primary": "#ffffff",
  "color-flash-semantic-text-inverse_secondary": "rgba(255, 255, 255, 0.8)",
  "color-flash-semantic-text-inverse_tertiary": "rgba(255, 255, 255, 0.6)",
  "color-flash-semantic-icon-neutral": "#606062",
  "color-flash-semantic-icon-neutral_subtle": "#aeafb2",
  "color-flash-semantic-icon-neutral_bold": "#121212",
  "color-flash-semantic-icon-neutral_inverse": "#ffffff",
  "color-flash-semantic-icon-neutral_inverse_subtle": "rgba(255, 255, 255, 0.8)",
  "color-flash-semantic-icon-critical": "#e04a62",
  "color-flash-semantic-icon-warning": "#bc7d24",
  "color-flash-semantic-icon-success": "#00a375",
  "color-flash-semantic-icon-info": "#617de0",
  "color-flash-semantic-icon-highlight": "#009bb2",
  "color-flash-semantic-icon-interactive": "#3257c8",
  "color-flash-semantic-border-neutral": "#d1d1d1",
  "color-flash-semantic-border-neutral_subtle": "#e6e6e6",
  "color-flash-semantic-border-neutral_bold": "#aeafb2",
  "color-flash-semantic-border-neutral_boldest": "#121212",
  "color-flash-semantic-border-neutral_inverse": "#ffffff",
  "color-flash-semantic-border-critical": "#f88d9e",
  "color-flash-semantic-border-warning": "#e2a22c",
  "color-flash-semantic-border-success": "#00c288",
  "color-flash-semantic-border-info": "#8c9ee8",
  "color-flash-semantic-border-highlight": "#45d1de",
  "color-flash-semantic-border-interactive": "#3257c8",
  "color-flash-semantic-border-interactive_hovered": "#1c34ba",
  "color-flash-semantic-border-interactive_pressed": "#1c34ba",
  "color-flash-semantic-surface-primary": "#ffffff",
  "color-flash-semantic-surface-secondary": "#f7f7f7",
  "color-flash-semantic-surface-disabled": "#d1d1d1",
  "color-flash-semantic-surface-hovered": "#e6e6e6",
  "color-flash-semantic-surface-selected": "#ebefff",
  "color-flash-semantic-surface-pressed": "#d1d1d1",
  "color-flash-semantic-surface-inverse": "#2e2e2d",
  "color-flash-semantic-surface-critical": "#bf132f",
  "color-flash-semantic-surface-critical_hovered": "#950019",
  "color-flash-semantic-surface-critical_pressed": "#680011",
  "color-flash-semantic-surface-critical_subtle": "#fff5f8",
  "color-flash-semantic-surface-critical_bold": "#680011",
  "color-flash-semantic-surface-warning": "#9e6100",
  "color-flash-semantic-surface-warning_subtle": "#fff8db",
  "color-flash-semantic-surface-warning_bold": "#5c3200",
  "color-flash-semantic-surface-success": "#007a58",
  "color-flash-semantic-surface-success_subtle": "#dffbe4",
  "color-flash-semantic-surface-success_bold": "#073c26",
  "color-flash-semantic-surface-info": "#3257c8",
  "color-flash-semantic-surface-info_subtle": "#ebefff",
  "color-flash-semantic-surface-info_bold": "#0d1477",
  "color-flash-semantic-surface-highlight": "#097186",
  "color-flash-semantic-surface-highlight_subtle": "#e5f9fa",
  "color-flash-semantic-surface-highlight_dark": "#0f343e",
  "color-flash-semantic-surface-interactive": "#3257c8",
  "color-flash-semantic-surface-interactive_hovered": "#1c34ba",
  "color-flash-semantic-surface-interactive_pressed": "#0d1477",
  "color-bootstrap-white": "#ffffff",
  "color-bootstrap-black": "#000000",
  "color-bootstrap-gray": "#aeafb2",
  "color-bootstrap-blue": "#617de0",
  "color-bootstrap-indigo": "#1c34ba",
  "color-bootstrap-purple": "#815af0",
  "color-bootstrap-pink": "#f7abab",
  "color-bootstrap-red": "#e04a62",
  "color-bootstrap-orange": "#ff913d",
  "color-bootstrap-yellow": "#fbcd5b",
  "color-bootstrap-green": "#00a375",
  "color-bootstrap-teal": "#009bb2",
  "color-bootstrap-cyan": "#009bb2",
  "spacing-bootstrap-spacer": "16px",
  "spacing-bootstrap-0": "0",
  "spacing-bootstrap-1": "0.25rem",
  "spacing-bootstrap-2": "0.5rem",
  "spacing-bootstrap-3": "1rem",
  "spacing-bootstrap-4": "1.5rem",
  "spacing-bootstrap-5": "3rem",
  "spacing-flash-0": "0",
  "spacing-flash-025": "0.125rem",
  "spacing-flash-050": "0.25rem",
  "spacing-flash-100": "0.5rem",
  "spacing-flash-150": "0.75rem",
  "spacing-flash-200": "1rem",
  "spacing-flash-250": "1.25rem",
  "spacing-flash-300": "1.5rem",
  "spacing-flash-400": "2rem",
  "spacing-flash-500": "2.5rem",
  "spacing-flash-600": "3rem",
  "spacing-flash-800": "4rem",
  "spacing-flash-1000": "5rem",
  "spacing-flash-1200": "6rem",
  "spacing-flash-1400": "7rem",
  "spacing-flash-1600": "8rem",
  "spacing-flashd-013": "0.0625rem",
  "spacing-flashd-038": "0.1875rem",
  "spacing-flashd-075": "0.375rem",
  "spacing-flashd-088": "0.4375rem",
  "spacing-flashd-113": "0.5625rem",
  "spacing-flashd-125": "0.625rem",
  "spacing-flashd-138": "0.6875rem",
  "spacing-flashd-175": "0.875rem",
  "spacing-flashd-188": "0.9375rem",
  "spacing-flashd-225": "1.125rem",
  "spacing-flashd-238": "1.1875rem",
  "spacing-flashd-450": "2.25rem",
  "spacing-flashd-1350": "6.75rem",
  "spacing-flashd-1500": "7.5rem",
  "typography-flash-core-font-size-100": "0.75rem",
  "typography-flash-core-font-size-200": "0.875rem",
  "typography-flash-core-font-size-300": "1rem",
  "typography-flash-core-font-size-400": "1.25rem",
  "typography-flash-core-font-size-500": "1.5rem",
  "typography-flash-core-font-size-600": "1.75rem",
  "typography-flash-core-font-size-700": "2rem",
  "typography-flash-core-font-size-800": "2.5rem",
  "typography-flash-core-font-size-900": "3rem",
  "typography-flash-core-font-weight-regular": "400",
  "typography-flash-core-font-weight-medium": "500",
  "typography-flash-core-font-weight-semibold": "600",
  "typography-flash-core-font-weight-bold": "700",
  "typography-flash-core-font-line_height-0": "0.75rem",
  "typography-flash-core-font-line_height-1": "1rem",
  "typography-flash-core-font-line_height-2": "1.25rem",
  "typography-flash-core-font-line_height-3": "1.5rem",
  "typography-flash-core-font-line_height-4": "1.75rem",
  "typography-flash-core-font-line_height-5": "2rem",
  "typography-flash-core-font-line_height-6": "2.5rem",
  "typography-flash-core-font-line_height-7": "2.75rem",
  "typography-flash-core-font-line_height-8": "3rem",
  "typography-flash-semantic-font-heading-weight_large": "700",
  "typography-flash-semantic-font-heading-weight_small": "600",
  "typography-flash-semantic-font-heading-xs-size": "0.75rem",
  "typography-flash-semantic-font-heading-xs-line_height": "1.25rem",
  "typography-flash-semantic-font-heading-s-size": "0.875rem",
  "typography-flash-semantic-font-heading-s-line_height": "1.25rem",
  "typography-flash-semantic-font-heading-m-size": "1rem",
  "typography-flash-semantic-font-heading-m-line_height": "1.25rem",
  "typography-flash-semantic-font-heading-l-size": "1.25rem",
  "typography-flash-semantic-font-heading-l-line_height": "1.5rem",
  "typography-flash-semantic-font-heading-xl-size": "1.5rem",
  "typography-flash-semantic-font-heading-xl-line_height": "2rem",
  "typography-flash-semantic-font-heading-xl2-size": "1.75rem",
  "typography-flash-semantic-font-heading-xl2-line_height": "2.5rem",
  "typography-flash-semantic-font-heading-xl3-size": "2rem",
  "typography-flash-semantic-font-heading-xl3-line_height": "2.75rem",
  "typography-flash-semantic-font-heading-xl4-size": "2.5rem",
  "typography-flash-semantic-font-heading-xl4-line_height": "3rem",
  "typography-flash-semantic-font-body-weight": "400",
  "typography-flash-semantic-font-body-xs-size": "0.75rem",
  "typography-flash-semantic-font-body-xs-line_height": "1.25rem",
  "typography-flash-semantic-font-body-s-size": "0.875rem",
  "typography-flash-semantic-font-body-s-line_height": "1.25rem",
  "typography-flash-semantic-font-body-m-size": "1rem",
  "typography-flash-semantic-font-body-m-line_height": "1.5rem",
  "typography-flash-semantic-font-body-l-size": "1.25rem",
  "typography-flash-semantic-font-body-l-line_height": "1.75rem",
  "typography-flash-semantic-font-label-weight": "500",
  "typography-flash-semantic-font-label-xs-size": "0.75rem",
  "typography-flash-semantic-font-label-xs-line_height": "0.75rem",
  "typography-flash-semantic-font-label-s-size": "0.875rem",
  "typography-flash-semantic-font-label-s-line_height": "1rem",
  "typography-flash-semantic-font-label-m-size": "1rem",
  "typography-flash-semantic-font-label-m-line_height": "1rem",
  "typography-flash-semantic-font-label-l-size": "1.25rem",
  "typography-flash-semantic-font-label-l-line_height": "1.25rem",
  "button-variants-primary-base-background-color": "#3257c8",
  "button-variants-primary-base-border-color": "#3257c8",
  "button-variants-primary-base-color": "#ffffff",
  "button-variants-primary-hover-background-color": "#1c34ba",
  "button-variants-primary-hover-color": "#ffffff",
  "button-variants-primary-focus-background-color": "#3257c8",
  "button-variants-primary-focus-color": "#ffffff",
  "button-variants-primary-pressed-background-color": "#0d1477",
  "button-variants-primary-pressed-color": "#ffffff",
  "button-variants-primary-selected-background-color": "#3257c8",
  "button-variants-primary-selected-border-color": "#3257c8",
  "button-variants-primary-selected-color": "#ffffff",
  "button-variants-secondary-base-background-color": "#ffffff",
  "button-variants-secondary-base-border-color": "#aeafb2",
  "button-variants-secondary-base-color": "#121212",
  "button-variants-secondary-hover-background-color": "#e6e6e6",
  "button-variants-secondary-hover-border-color": "#1c34ba",
  "button-variants-secondary-hover-color": "#1c34ba",
  "button-variants-secondary-focus-background-color": "#ebefff",
  "button-variants-secondary-focus-color": "#1c34ba",
  "button-variants-secondary-pressed-background-color": "#d1d1d1",
  "button-variants-secondary-pressed-border-color": "#1c34ba",
  "button-variants-secondary-pressed-color": "#0d1477",
  "button-variants-secondary-selected-background-color": "#ebefff",
  "button-variants-secondary-selected-border-color": "#3257c8",
  "button-variants-secondary-selected-color": "#1c34ba",
  "button-variants-tertiary-base-background-color": "#ffffff",
  "button-variants-tertiary-base-border-color": "#ffffff",
  "button-variants-tertiary-base-color": "#3257c8",
  "button-variants-tertiary-hover-background-color": "#e6e6e6",
  "button-variants-tertiary-hover-border-color": "#e6e6e6",
  "button-variants-tertiary-hover-color": "#3257c8",
  "button-variants-tertiary-focus-background-color": "#ebefff",
  "button-variants-tertiary-focus-color": "#3257c8",
  "button-variants-tertiary-pressed-background-color": "#d1d1d1",
  "button-variants-tertiary-pressed-border-color": "#d1d1d1",
  "button-variants-tertiary-pressed-color": "#0d1477",
  "button-variants-tertiary-selected-background-color": "#ebefff",
  "button-variants-tertiary-selected-border-color": "#ebefff",
  "button-variants-tertiary-selected-color": "#3257c8",
  "button-variants-tertiary_subtle-base-background-color": "#ffffff",
  "button-variants-tertiary_subtle-base-border-color": "#ffffff",
  "button-variants-tertiary_subtle-base-color": "#121212",
  "button-variants-tertiary_subtle-hover-background-color": "#e6e6e6",
  "button-variants-tertiary_subtle-hover-border-color": "#e6e6e6",
  "button-variants-tertiary_subtle-hover-color": "#3257c8",
  "button-variants-tertiary_subtle-focus-background-color": "#ebefff",
  "button-variants-tertiary_subtle-focus-color": "#3257c8",
  "button-variants-tertiary_subtle-pressed-background-color": "#d1d1d1",
  "button-variants-tertiary_subtle-pressed-border-color": "#d1d1d1",
  "button-variants-tertiary_subtle-pressed-color": "#0d1477",
  "button-variants-tertiary_subtle-selected-background-color": "#ebefff",
  "button-variants-tertiary_subtle-selected-border-color": "#ebefff",
  "button-variants-tertiary_subtle-selected-color": "#3257c8",
  "button-variants-critical-base-background-color": "#bf132f",
  "button-variants-critical-base-border-color": "#bf132f",
  "button-variants-critical-base-color": "#ffffff",
  "button-variants-critical-hover-background-color": "#950019",
  "button-variants-critical-hover-border-color": "#950019",
  "button-variants-critical-hover-color": "#ffffff",
  "button-variants-critical-focus-background-color": "#bf132f",
  "button-variants-critical-focus-color": "#ffffff",
  "button-variants-critical-pressed-background-color": "#950019",
  "button-variants-critical-pressed-border-color": "#950019",
  "button-variants-critical-pressed-color": "#ffffff",
  "button-variants-critical-selected-background-color": "#bf132f",
  "button-variants-critical-selected-border-color": "#bf132f",
  "button-variants-critical-selected-color": "#ffffff",
  "button-variants-icon_only_default-base-background-color": "transparent",
  "button-variants-icon_only_default-base-border-color": "transparent",
  "button-variants-icon_only_default-base-color": "#606062",
  "button-variants-icon_only_default-hover-background-color": "transparent",
  "button-variants-icon_only_default-hover-border-color": "transparent",
  "button-variants-icon_only_default-hover-color": "#3257c8",
  "button-variants-icon_only_default-focus-background-color": "transparent",
  "button-variants-icon_only_default-focus-border-color": "transparent",
  "button-variants-icon_only_default-focus-color": "#3257c8",
  "button-variants-icon_only_default-pressed-background-color": "transparent",
  "button-variants-icon_only_default-pressed-border-color": "transparent",
  "button-variants-icon_only_default-pressed-color": "#3257c8",
  "button-variants-icon_only_default-selected-background-color": "transparent",
  "button-variants-icon_only_default-selected-border-color": "transparent",
  "button-variants-icon_only_default-selected-color": "#3257c8",
  "button-variants-icon_only_inverse-base-background-color": "#2e2e2d",
  "button-variants-icon_only_inverse-base-border-color": "#2e2e2d",
  "button-variants-icon_only_inverse-base-color": "rgba(255, 255, 255, 0.8)",
  "button-variants-icon_only_inverse-hover-border-color": "#2e2e2d",
  "button-variants-icon_only_inverse-hover-color": "#ffffff",
  "button-variants-icon_only_inverse-focus-color": "#ffffff",
  "button-variants-icon_only_inverse-pressed-border-color": "#2e2e2d",
  "button-variants-icon_only_inverse-pressed-color": "#ffffff",
  "button-variants-icon_only_contained-base-background-color": "#ffffff",
  "button-variants-icon_only_contained-base-border-color": "#aeafb2",
  "button-variants-icon_only_contained-base-color": "#606062",
  "button-variants-icon_only_contained-hover-background-color": "#e6e6e6",
  "button-variants-icon_only_contained-hover-border-color": "#e6e6e6",
  "button-variants-icon_only_contained-hover-color": "#3257c8",
  "button-variants-icon_only_contained-focus-background-color": "#ffffff",
  "button-variants-icon_only_contained-focus-border-color": "#ffffff",
  "button-variants-icon_only_contained-focus-color": "#3257c8",
  "button-variants-icon_only_contained-pressed-background-color": "#e6e6e6",
  "button-variants-icon_only_contained-pressed-border-color": "#e6e6e6",
  "button-variants-icon_only_contained-pressed-color": "#3257c8",
  "button-variants-icon_only_contained-selected-background-color": "#ebefff",
  "button-variants-icon_only_contained-selected-border-color": "#ebefff",
  "button-variants-icon_only_contained-selected-color": "#3257c8",
  "button-variants-icon_only_critical-base-background-color": "transparent",
  "button-variants-icon_only_critical-base-border-color": "transparent",
  "button-variants-icon_only_critical-base-color": "#e04a62",
  "button-variants-icon_only_critical-hover-background-color": "transparent",
  "button-variants-icon_only_critical-hover-border-color": "transparent",
  "button-variants-icon_only_critical-hover-color": "#950019",
  "button-variants-icon_only_critical-focus-background-color": "transparent",
  "button-variants-icon_only_critical-focus-border-color": "transparent",
  "button-variants-icon_only_critical-focus-color": "#950019",
  "button-variants-icon_only_critical-pressed-background-color": "transparent",
  "button-variants-icon_only_critical-pressed-border-color": "transparent",
  "button-variants-icon_only_critical-pressed-color": "#950019",
  "button-variants-icon_only_critical-selected-background-color": "transparent",
  "button-variants-icon_only_critical-selected-border-color": "transparent",
  "button-variants-icon_only_critical-selected-color": "#bf132f",
  "button-variants-link-base-color": "#3257c8",
  "button-variants-link-hover-color": "#1c34ba",
  "button-variants-link_subtle-base-color": "#121212",
  "button-variants-link_subtle-hover-color": "#1c34ba",
  "button-variants-link_critical-base-color": "#bf132f",
  "button-variants-link_critical-hover-color": "#680011",
  "elevation-flash-core-none": "0 0 0 transparent",
  "elevation-flash-core-base": "0 0.0625rem 0.1875rem 0 rgba(10, 12, 61, 0.12)",
  "elevation-flash-core-100": "0 0.125rem 0.375rem 0 rgba(10, 12, 61, 0.24)",
  "elevation-flash-core-300": "0 0.5rem 1rem 0 rgba(10, 12, 61, 0.24)",
  "elevation-flash-core-400": "0 0.75rem 1.5rem 0 rgba(10, 12, 61, 0.24)",
  "motion-flash-duration-short-1": "0.05",
  "motion-flash-duration-short-2": "0.1",
  "motion-flash-duration-short-3": "0.15",
  "motion-flash-duration-short-4": "0.2",
  "motion-flash-duration-medium-1": "0.25",
  "motion-flash-duration-medium-2": "0.3",
  "motion-flash-duration-medium-3": "0.35",
  "motion-flash-duration-medium-4": "0.4",
  "motion-flash-duration-long-1": "0.45",
  "motion-flash-duration-long-2": "0.5",
  "motion-flash-duration-long-3": "0.55",
  "motion-flash-duration-long-4": "0.6",
  "motion-flash-duration-extra_long-1": "0.7",
  "motion-flash-duration-extra_long-2": "0.8",
  "motion-flash-duration-extra_long-3": "0.9",
  "motion-flash-duration-extra_long-4": "1"
}, sass = {
  breakpoints: {
    mobile_portrait: parseInt(sassModule["breakpoints-mobile_portrait"]),
    mobile_landscape: parseInt(sassModule["breakpoints-mobile_landscape"]),
    tablet: parseInt(sassModule["breakpoints-tablet"])
  },
  color: {
    flash: {
      brand: {
        coral: sassModule["color-flash-brand-coral"],
        yellow: sassModule["color-flash-brand-yellow"],
        orange: sassModule["color-flash-brand-orange"],
        blue: sassModule["color-flash-brand-blue"],
        teal: sassModule["color-flash-brand-teal"],
        cream: sassModule["color-flash-brand-cream"],
        charcoal: sassModule["color-flash-brand-charcoal"]
      },
      core: {
        neutral: {
          10: sassModule["color-flash-core-neutral-10"],
          20: sassModule["color-flash-core-neutral-20"],
          30: sassModule["color-flash-core-neutral-30"],
          40: sassModule["color-flash-core-neutral-40"],
          50: sassModule["color-flash-core-neutral-50"],
          60: sassModule["color-flash-core-neutral-60"],
          70: sassModule["color-flash-core-neutral-70"],
          80: sassModule["color-flash-core-neutral-80"],
          "00": sassModule["color-flash-core-neutral-00"],
          "05": sassModule["color-flash-core-neutral-05"]
        },
        red: {
          10: sassModule["color-flash-core-red-10"],
          20: sassModule["color-flash-core-red-20"],
          30: sassModule["color-flash-core-red-30"],
          40: sassModule["color-flash-core-red-40"],
          50: sassModule["color-flash-core-red-50"],
          60: sassModule["color-flash-core-red-60"],
          70: sassModule["color-flash-core-red-70"],
          80: sassModule["color-flash-core-red-80"],
          "00": sassModule["color-flash-core-red-00"]
        },
        coral: {
          10: sassModule["color-flash-core-coral-10"],
          20: sassModule["color-flash-core-coral-20"],
          30: sassModule["color-flash-core-coral-30"],
          40: sassModule["color-flash-core-coral-40"],
          50: sassModule["color-flash-core-coral-50"],
          60: sassModule["color-flash-core-coral-60"],
          70: sassModule["color-flash-core-coral-70"],
          80: sassModule["color-flash-core-coral-80"],
          "00": sassModule["color-flash-core-coral-00"]
        },
        orange: {
          10: sassModule["color-flash-core-orange-10"],
          20: sassModule["color-flash-core-orange-20"],
          30: sassModule["color-flash-core-orange-30"],
          40: sassModule["color-flash-core-orange-40"],
          50: sassModule["color-flash-core-orange-50"],
          60: sassModule["color-flash-core-orange-60"],
          70: sassModule["color-flash-core-orange-70"],
          80: sassModule["color-flash-core-orange-80"],
          "00": sassModule["color-flash-core-orange-00"]
        },
        yellow: {
          10: sassModule["color-flash-core-yellow-10"],
          20: sassModule["color-flash-core-yellow-20"],
          30: sassModule["color-flash-core-yellow-30"],
          40: sassModule["color-flash-core-yellow-40"],
          50: sassModule["color-flash-core-yellow-50"],
          60: sassModule["color-flash-core-yellow-60"],
          70: sassModule["color-flash-core-yellow-70"],
          80: sassModule["color-flash-core-yellow-80"],
          "00": sassModule["color-flash-core-yellow-00"]
        },
        green: {
          10: sassModule["color-flash-core-green-10"],
          20: sassModule["color-flash-core-green-20"],
          30: sassModule["color-flash-core-green-30"],
          40: sassModule["color-flash-core-green-40"],
          50: sassModule["color-flash-core-green-50"],
          60: sassModule["color-flash-core-green-60"],
          70: sassModule["color-flash-core-green-70"],
          80: sassModule["color-flash-core-green-80"],
          "00": sassModule["color-flash-core-green-00"]
        },
        teal: {
          10: sassModule["color-flash-core-teal-10"],
          20: sassModule["color-flash-core-teal-20"],
          30: sassModule["color-flash-core-teal-30"],
          40: sassModule["color-flash-core-teal-40"],
          50: sassModule["color-flash-core-teal-50"],
          60: sassModule["color-flash-core-teal-60"],
          70: sassModule["color-flash-core-teal-70"],
          80: sassModule["color-flash-core-teal-80"],
          "00": sassModule["color-flash-core-teal-00"]
        },
        blue: {
          10: sassModule["color-flash-core-blue-10"],
          20: sassModule["color-flash-core-blue-20"],
          30: sassModule["color-flash-core-blue-30"],
          40: sassModule["color-flash-core-blue-40"],
          50: sassModule["color-flash-core-blue-50"],
          60: sassModule["color-flash-core-blue-60"],
          70: sassModule["color-flash-core-blue-70"],
          80: sassModule["color-flash-core-blue-80"],
          "00": sassModule["color-flash-core-blue-00"]
        },
        purple: {
          10: sassModule["color-flash-core-purple-10"],
          20: sassModule["color-flash-core-purple-20"],
          30: sassModule["color-flash-core-purple-30"],
          40: sassModule["color-flash-core-purple-40"],
          50: sassModule["color-flash-core-purple-50"],
          60: sassModule["color-flash-core-purple-60"],
          70: sassModule["color-flash-core-purple-70"],
          80: sassModule["color-flash-core-purple-80"],
          "00": sassModule["color-flash-core-purple-00"]
        }
      },
      semantic: {
        text: {
          primary: sassModule["color-flash-semantic-text-primary"],
          secondary: sassModule["color-flash-semantic-text-secondary"],
          tertiary: sassModule["color-flash-semantic-text-tertiary"],
          critical: sassModule["color-flash-semantic-text-critical"],
          warning: sassModule["color-flash-semantic-text-warning"],
          success: sassModule["color-flash-semantic-text-success"],
          info: sassModule["color-flash-semantic-text-info"],
          highlight: sassModule["color-flash-semantic-text-highlight"],
          interactive: sassModule["color-flash-semantic-text-interactive"],
          interactive_hovered: sassModule["color-flash-semantic-text-interactive_hovered"],
          interactive_pressed: sassModule["color-flash-semantic-text-interactive_pressed"],
          inverse_primary: sassModule["color-flash-semantic-text-inverse_primary"],
          inverse_secondary: sassModule["color-flash-semantic-text-inverse_secondary"],
          inverse_tertiary: sassModule["color-flash-semantic-text-inverse_tertiary"]
        },
        icon: {
          neutral: sassModule["color-flash-semantic-icon-neutral"],
          neutral_subtle: sassModule["color-flash-semantic-icon-neutral_subtle"],
          neutral_bold: sassModule["color-flash-semantic-icon-neutral_bold"],
          neutral_inverse: sassModule["color-flash-semantic-icon-neutral_inverse"],
          neutral_inverse_subtle: sassModule["color-flash-semantic-icon-neutral_inverse_subtle"],
          critical: sassModule["color-flash-semantic-icon-critical"],
          warning: sassModule["color-flash-semantic-icon-warning"],
          success: sassModule["color-flash-semantic-icon-success"],
          info: sassModule["color-flash-semantic-icon-info"],
          highlight: sassModule["color-flash-semantic-icon-highlight"],
          interactive: sassModule["color-flash-semantic-icon-interactive"]
        },
        border: {
          neutral: sassModule["color-flash-semantic-border-neutral"],
          neutral_subtle: sassModule["color-flash-semantic-border-neutral_subtle"],
          neutral_bold: sassModule["color-flash-semantic-border-neutral_bold"],
          neutral_boldest: sassModule["color-flash-semantic-border-neutral_boldest"],
          neutral_inverse: sassModule["color-flash-semantic-border-neutral_inverse"],
          critical: sassModule["color-flash-semantic-border-critical"],
          warning: sassModule["color-flash-semantic-border-warning"],
          success: sassModule["color-flash-semantic-border-success"],
          info: sassModule["color-flash-semantic-border-info"],
          highlight: sassModule["color-flash-semantic-border-highlight"],
          interactive: sassModule["color-flash-semantic-border-interactive"],
          interactive_hovered: sassModule["color-flash-semantic-border-interactive_hovered"],
          interactive_pressed: sassModule["color-flash-semantic-border-interactive_pressed"]
        },
        surface: {
          primary: sassModule["color-flash-semantic-surface-primary"],
          secondary: sassModule["color-flash-semantic-surface-secondary"],
          disabled: sassModule["color-flash-semantic-surface-disabled"],
          hovered: sassModule["color-flash-semantic-surface-hovered"],
          selected: sassModule["color-flash-semantic-surface-selected"],
          pressed: sassModule["color-flash-semantic-surface-pressed"],
          inverse: sassModule["color-flash-semantic-surface-inverse"],
          critical: sassModule["color-flash-semantic-surface-critical"],
          critical_hovered: sassModule["color-flash-semantic-surface-critical_hovered"],
          critical_pressed: sassModule["color-flash-semantic-surface-critical_pressed"],
          critical_subtle: sassModule["color-flash-semantic-surface-critical_subtle"],
          critical_bold: sassModule["color-flash-semantic-surface-critical_bold"],
          warning: sassModule["color-flash-semantic-surface-warning"],
          warning_subtle: sassModule["color-flash-semantic-surface-warning_subtle"],
          warning_bold: sassModule["color-flash-semantic-surface-warning_bold"],
          success: sassModule["color-flash-semantic-surface-success"],
          success_subtle: sassModule["color-flash-semantic-surface-success_subtle"],
          success_bold: sassModule["color-flash-semantic-surface-success_bold"],
          info: sassModule["color-flash-semantic-surface-info"],
          info_subtle: sassModule["color-flash-semantic-surface-info_subtle"],
          info_bold: sassModule["color-flash-semantic-surface-info_bold"],
          highlight: sassModule["color-flash-semantic-surface-highlight"],
          highlight_subtle: sassModule["color-flash-semantic-surface-highlight_subtle"],
          highlight_dark: sassModule["color-flash-semantic-surface-highlight_dark"],
          interactive: sassModule["color-flash-semantic-surface-interactive"],
          interactive_hovered: sassModule["color-flash-semantic-surface-interactive_hovered"],
          interactive_pressed: sassModule["color-flash-semantic-surface-interactive_pressed"]
        }
      }
    },
    bootstrap: {
      white: sassModule["color-bootstrap-white"],
      black: sassModule["color-bootstrap-black"],
      gray: sassModule["color-bootstrap-gray"],
      blue: sassModule["color-bootstrap-blue"],
      indigo: sassModule["color-bootstrap-indigo"],
      purple: sassModule["color-bootstrap-purple"],
      pink: sassModule["color-bootstrap-pink"],
      red: sassModule["color-bootstrap-red"],
      orange: sassModule["color-bootstrap-orange"],
      yellow: sassModule["color-bootstrap-yellow"],
      green: sassModule["color-bootstrap-green"],
      teal: sassModule["color-bootstrap-teal"],
      cyan: sassModule["color-bootstrap-cyan"]
    }
  },
  spacing: {
    bootstrap: {
      0: sassModule["spacing-bootstrap-0"],
      1: sassModule["spacing-bootstrap-1"],
      2: sassModule["spacing-bootstrap-2"],
      3: sassModule["spacing-bootstrap-3"],
      4: sassModule["spacing-bootstrap-4"],
      5: sassModule["spacing-bootstrap-5"],
      spacer: parseInt(sassModule["spacing-bootstrap-spacer"])
    },
    flash: {
      0: sassModule["spacing-flash-0"],
      100: sassModule["spacing-flash-100"],
      150: sassModule["spacing-flash-150"],
      200: sassModule["spacing-flash-200"],
      250: sassModule["spacing-flash-250"],
      300: sassModule["spacing-flash-300"],
      400: sassModule["spacing-flash-400"],
      500: sassModule["spacing-flash-500"],
      600: sassModule["spacing-flash-600"],
      800: sassModule["spacing-flash-800"],
      1e3: sassModule["spacing-flash-1000"],
      1200: sassModule["spacing-flash-1200"],
      1400: sassModule["spacing-flash-1400"],
      1600: sassModule["spacing-flash-1600"],
      "025": sassModule["spacing-flash-025"],
      "050": sassModule["spacing-flash-050"]
    },
    flashd: {
      113: sassModule["spacing-flashd-113"],
      125: sassModule["spacing-flashd-125"],
      138: sassModule["spacing-flashd-138"],
      175: sassModule["spacing-flashd-175"],
      188: sassModule["spacing-flashd-188"],
      225: sassModule["spacing-flashd-225"],
      238: sassModule["spacing-flashd-238"],
      450: sassModule["spacing-flashd-450"],
      1350: sassModule["spacing-flashd-1350"],
      1500: sassModule["spacing-flashd-1500"],
      "013": sassModule["spacing-flashd-013"],
      "038": sassModule["spacing-flashd-038"],
      "075": sassModule["spacing-flashd-075"],
      "088": sassModule["spacing-flashd-088"]
    }
  },
  typography: {
    flash: {
      core: {
        font: {
          size: {
            100: sassModule["typography-flash-core-font-size-100"],
            200: sassModule["typography-flash-core-font-size-200"],
            300: sassModule["typography-flash-core-font-size-300"],
            400: sassModule["typography-flash-core-font-size-400"],
            500: sassModule["typography-flash-core-font-size-500"],
            600: sassModule["typography-flash-core-font-size-600"],
            700: sassModule["typography-flash-core-font-size-700"],
            800: sassModule["typography-flash-core-font-size-800"],
            900: sassModule["typography-flash-core-font-size-900"]
          },
          weight: {
            regular: sassModule["typography-flash-core-font-weight-regular"],
            medium: sassModule["typography-flash-core-font-weight-medium"],
            semibold: sassModule["typography-flash-core-font-weight-semibold"],
            bold: sassModule["typography-flash-core-font-weight-bold"]
          },
          line_height: {
            0: sassModule["typography-flash-core-font-line_height-0"],
            1: sassModule["typography-flash-core-font-line_height-1"],
            2: sassModule["typography-flash-core-font-line_height-2"],
            3: sassModule["typography-flash-core-font-line_height-3"],
            4: sassModule["typography-flash-core-font-line_height-4"],
            5: sassModule["typography-flash-core-font-line_height-5"],
            6: sassModule["typography-flash-core-font-line_height-6"],
            7: sassModule["typography-flash-core-font-line_height-7"],
            8: sassModule["typography-flash-core-font-line_height-8"]
          }
        }
      },
      semantic: {
        font: {
          heading: {
            weight_large: sassModule["typography-flash-semantic-font-heading-weight_large"],
            weight_small: sassModule["typography-flash-semantic-font-heading-weight_small"],
            xs: {
              size: sassModule["typography-flash-semantic-font-heading-xs-size"],
              line_height: sassModule["typography-flash-semantic-font-heading-xs-line_height"]
            },
            s: {
              size: sassModule["typography-flash-semantic-font-heading-s-size"],
              line_height: sassModule["typography-flash-semantic-font-heading-s-line_height"]
            },
            m: {
              size: sassModule["typography-flash-semantic-font-heading-m-size"],
              line_height: sassModule["typography-flash-semantic-font-heading-m-line_height"]
            },
            l: {
              size: sassModule["typography-flash-semantic-font-heading-l-size"],
              line_height: sassModule["typography-flash-semantic-font-heading-l-line_height"]
            },
            xl: {
              size: sassModule["typography-flash-semantic-font-heading-xl-size"],
              line_height: sassModule["typography-flash-semantic-font-heading-xl-line_height"]
            },
            xl2: {
              size: sassModule["typography-flash-semantic-font-heading-xl2-size"],
              line_height: sassModule["typography-flash-semantic-font-heading-xl2-line_height"]
            },
            xl3: {
              size: sassModule["typography-flash-semantic-font-heading-xl3-size"],
              line_height: sassModule["typography-flash-semantic-font-heading-xl3-line_height"]
            },
            xl4: {
              size: sassModule["typography-flash-semantic-font-heading-xl4-size"],
              line_height: sassModule["typography-flash-semantic-font-heading-xl4-line_height"]
            }
          },
          body: {
            weight: sassModule["typography-flash-semantic-font-body-weight"],
            xs: {
              size: sassModule["typography-flash-semantic-font-body-xs-size"],
              line_height: sassModule["typography-flash-semantic-font-body-xs-line_height"]
            },
            s: {
              size: sassModule["typography-flash-semantic-font-body-s-size"],
              line_height: sassModule["typography-flash-semantic-font-body-s-line_height"]
            },
            m: {
              size: sassModule["typography-flash-semantic-font-body-m-size"],
              line_height: sassModule["typography-flash-semantic-font-body-m-line_height"]
            },
            l: {
              size: sassModule["typography-flash-semantic-font-body-l-size"],
              line_height: sassModule["typography-flash-semantic-font-body-l-line_height"]
            }
          },
          label: {
            weight: sassModule["typography-flash-semantic-font-label-weight"],
            xs: {
              size: sassModule["typography-flash-semantic-font-label-xs-size"],
              line_height: sassModule["typography-flash-semantic-font-label-xs-line_height"]
            },
            s: {
              size: sassModule["typography-flash-semantic-font-label-s-size"],
              line_height: sassModule["typography-flash-semantic-font-label-s-line_height"]
            },
            m: {
              size: sassModule["typography-flash-semantic-font-label-m-size"],
              line_height: sassModule["typography-flash-semantic-font-label-m-line_height"]
            },
            l: {
              size: sassModule["typography-flash-semantic-font-label-l-size"],
              line_height: sassModule["typography-flash-semantic-font-label-l-line_height"]
            }
          }
        }
      }
    }
  },
  button: {
    variants: {
      primary: {
        base: {
          background: {
            color: sassModule["button-variants-primary-base-background-color"]
          },
          border: {
            color: sassModule["button-variants-primary-base-border-color"]
          },
          color: sassModule["button-variants-primary-base-color"]
        },
        hover: {
          background: {
            color: sassModule["button-variants-primary-hover-background-color"]
          },
          color: sassModule["button-variants-primary-hover-color"]
        },
        focus: {
          background: {
            color: sassModule["button-variants-primary-focus-background-color"]
          },
          color: sassModule["button-variants-primary-focus-color"]
        },
        pressed: {
          background: {
            color: sassModule["button-variants-primary-pressed-background-color"]
          },
          color: sassModule["button-variants-primary-pressed-color"]
        },
        selected: {
          background: {
            color: sassModule["button-variants-primary-selected-background-color"]
          },
          border: {
            color: sassModule["button-variants-primary-selected-border-color"]
          },
          color: sassModule["button-variants-primary-selected-color"]
        }
      },
      secondary: {
        base: {
          background: {
            color: sassModule["button-variants-secondary-base-background-color"]
          },
          border: {
            color: sassModule["button-variants-secondary-base-border-color"]
          },
          color: sassModule["button-variants-secondary-base-color"]
        },
        hover: {
          background: {
            color: sassModule["button-variants-secondary-hover-background-color"]
          },
          border: {
            color: sassModule["button-variants-secondary-hover-border-color"]
          },
          color: sassModule["button-variants-secondary-hover-color"]
        },
        focus: {
          background: {
            color: sassModule["button-variants-secondary-focus-background-color"]
          },
          color: sassModule["button-variants-secondary-focus-color"]
        },
        pressed: {
          background: {
            color: sassModule["button-variants-secondary-pressed-background-color"]
          },
          border: {
            color: sassModule["button-variants-secondary-pressed-border-color"]
          },
          color: sassModule["button-variants-secondary-pressed-color"]
        },
        selected: {
          background: {
            color: sassModule["button-variants-secondary-selected-background-color"]
          },
          border: {
            color: sassModule["button-variants-secondary-selected-border-color"]
          },
          color: sassModule["button-variants-secondary-selected-color"]
        }
      },
      tertiary: {
        base: {
          background: {
            color: sassModule["button-variants-tertiary-base-background-color"]
          },
          border: {
            color: sassModule["button-variants-tertiary-base-border-color"]
          },
          color: sassModule["button-variants-tertiary-base-color"]
        },
        hover: {
          background: {
            color: sassModule["button-variants-tertiary-hover-background-color"]
          },
          border: {
            color: sassModule["button-variants-tertiary-hover-border-color"]
          },
          color: sassModule["button-variants-tertiary-hover-color"]
        },
        focus: {
          background: {
            color: sassModule["button-variants-tertiary-focus-background-color"]
          },
          color: sassModule["button-variants-tertiary-focus-color"]
        },
        pressed: {
          background: {
            color: sassModule["button-variants-tertiary-pressed-background-color"]
          },
          border: {
            color: sassModule["button-variants-tertiary-pressed-border-color"]
          },
          color: sassModule["button-variants-tertiary-pressed-color"]
        },
        selected: {
          background: {
            color: sassModule["button-variants-tertiary-selected-background-color"]
          },
          border: {
            color: sassModule["button-variants-tertiary-selected-border-color"]
          },
          color: sassModule["button-variants-tertiary-selected-color"]
        }
      },
      tertiary_subtle: {
        base: {
          background: {
            color: sassModule["button-variants-tertiary_subtle-base-background-color"]
          },
          border: {
            color: sassModule["button-variants-tertiary_subtle-base-border-color"]
          },
          color: sassModule["button-variants-tertiary_subtle-base-color"]
        },
        hover: {
          background: {
            color: sassModule["button-variants-tertiary_subtle-hover-background-color"]
          },
          border: {
            color: sassModule["button-variants-tertiary_subtle-hover-border-color"]
          },
          color: sassModule["button-variants-tertiary_subtle-hover-color"]
        },
        focus: {
          background: {
            color: sassModule["button-variants-tertiary_subtle-focus-background-color"]
          },
          color: sassModule["button-variants-tertiary_subtle-focus-color"]
        },
        pressed: {
          background: {
            color: sassModule["button-variants-tertiary_subtle-pressed-background-color"]
          },
          border: {
            color: sassModule["button-variants-tertiary_subtle-pressed-border-color"]
          },
          color: sassModule["button-variants-tertiary_subtle-pressed-color"]
        },
        selected: {
          background: {
            color: sassModule["button-variants-tertiary_subtle-selected-background-color"]
          },
          border: {
            color: sassModule["button-variants-tertiary_subtle-selected-border-color"]
          },
          color: sassModule["button-variants-tertiary_subtle-selected-color"]
        }
      },
      critical: {
        base: {
          background: {
            color: sassModule["button-variants-critical-base-background-color"]
          },
          border: {
            color: sassModule["button-variants-critical-base-border-color"]
          },
          color: sassModule["button-variants-critical-base-color"]
        },
        hover: {
          background: {
            color: sassModule["button-variants-critical-hover-background-color"]
          },
          border: {
            color: sassModule["button-variants-critical-hover-border-color"]
          },
          color: sassModule["button-variants-critical-hover-color"]
        },
        focus: {
          background: {
            color: sassModule["button-variants-critical-focus-background-color"]
          },
          color: sassModule["button-variants-critical-focus-color"]
        },
        pressed: {
          background: {
            color: sassModule["button-variants-critical-pressed-background-color"]
          },
          border: {
            color: sassModule["button-variants-critical-pressed-border-color"]
          },
          color: sassModule["button-variants-critical-pressed-color"]
        },
        selected: {
          background: {
            color: sassModule["button-variants-critical-selected-background-color"]
          },
          border: {
            color: sassModule["button-variants-critical-selected-border-color"]
          },
          color: sassModule["button-variants-critical-selected-color"]
        }
      },
      icon_only_default: {
        base: {
          background: {
            color: sassModule["button-variants-icon_only_default-base-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_default-base-border-color"]
          },
          color: sassModule["button-variants-icon_only_default-base-color"]
        },
        hover: {
          background: {
            color: sassModule["button-variants-icon_only_default-hover-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_default-hover-border-color"]
          },
          color: sassModule["button-variants-icon_only_default-hover-color"]
        },
        focus: {
          background: {
            color: sassModule["button-variants-icon_only_default-focus-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_default-focus-border-color"]
          },
          color: sassModule["button-variants-icon_only_default-focus-color"]
        },
        pressed: {
          background: {
            color: sassModule["button-variants-icon_only_default-pressed-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_default-pressed-border-color"]
          },
          color: sassModule["button-variants-icon_only_default-pressed-color"]
        },
        selected: {
          background: {
            color: sassModule["button-variants-icon_only_default-selected-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_default-selected-border-color"]
          },
          color: sassModule["button-variants-icon_only_default-selected-color"]
        }
      },
      icon_only_inverse: {
        base: {
          background: {
            color: sassModule["button-variants-icon_only_inverse-base-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_inverse-base-border-color"]
          },
          color: sassModule["button-variants-icon_only_inverse-base-color"]
        },
        hover: {
          border: {
            color: sassModule["button-variants-icon_only_inverse-hover-border-color"]
          },
          color: sassModule["button-variants-icon_only_inverse-hover-color"]
        },
        focus: {
          color: sassModule["button-variants-icon_only_inverse-focus-color"]
        },
        pressed: {
          border: {
            color: sassModule["button-variants-icon_only_inverse-pressed-border-color"]
          },
          color: sassModule["button-variants-icon_only_inverse-pressed-color"]
        }
      },
      icon_only_contained: {
        base: {
          background: {
            color: sassModule["button-variants-icon_only_contained-base-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_contained-base-border-color"]
          },
          color: sassModule["button-variants-icon_only_contained-base-color"]
        },
        hover: {
          background: {
            color: sassModule["button-variants-icon_only_contained-hover-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_contained-hover-border-color"]
          },
          color: sassModule["button-variants-icon_only_contained-hover-color"]
        },
        focus: {
          background: {
            color: sassModule["button-variants-icon_only_contained-focus-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_contained-focus-border-color"]
          },
          color: sassModule["button-variants-icon_only_contained-focus-color"]
        },
        pressed: {
          background: {
            color: sassModule["button-variants-icon_only_contained-pressed-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_contained-pressed-border-color"]
          },
          color: sassModule["button-variants-icon_only_contained-pressed-color"]
        },
        selected: {
          background: {
            color: sassModule["button-variants-icon_only_contained-selected-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_contained-selected-border-color"]
          },
          color: sassModule["button-variants-icon_only_contained-selected-color"]
        }
      },
      icon_only_critical: {
        base: {
          background: {
            color: sassModule["button-variants-icon_only_critical-base-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_critical-base-border-color"]
          },
          color: sassModule["button-variants-icon_only_critical-base-color"]
        },
        hover: {
          background: {
            color: sassModule["button-variants-icon_only_critical-hover-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_critical-hover-border-color"]
          },
          color: sassModule["button-variants-icon_only_critical-hover-color"]
        },
        focus: {
          background: {
            color: sassModule["button-variants-icon_only_critical-focus-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_critical-focus-border-color"]
          },
          color: sassModule["button-variants-icon_only_critical-focus-color"]
        },
        pressed: {
          background: {
            color: sassModule["button-variants-icon_only_critical-pressed-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_critical-pressed-border-color"]
          },
          color: sassModule["button-variants-icon_only_critical-pressed-color"]
        },
        selected: {
          background: {
            color: sassModule["button-variants-icon_only_critical-selected-background-color"]
          },
          border: {
            color: sassModule["button-variants-icon_only_critical-selected-border-color"]
          },
          color: sassModule["button-variants-icon_only_critical-selected-color"]
        }
      },
      link: {
        base: { color: sassModule["button-variants-link-base-color"] },
        hover: { color: sassModule["button-variants-link-hover-color"] }
      },
      link_subtle: {
        base: {
          color: sassModule["button-variants-link_subtle-base-color"]
        },
        hover: {
          color: sassModule["button-variants-link_subtle-hover-color"]
        }
      },
      link_critical: {
        base: {
          color: sassModule["button-variants-link_critical-base-color"]
        },
        hover: {
          color: sassModule["button-variants-link_critical-hover-color"]
        }
      }
    }
  },
  elevation: {
    flash: {
      core: {
        100: sassModule["elevation-flash-core-100"],
        300: sassModule["elevation-flash-core-300"],
        400: sassModule["elevation-flash-core-400"],
        none: sassModule["elevation-flash-core-none"],
        base: sassModule["elevation-flash-core-base"]
      }
    }
  },
  motion: {
    flash: {
      duration: {
        short: {
          1: parseFloat(sassModule["motion-flash-duration-short-1"]),
          2: parseFloat(sassModule["motion-flash-duration-short-2"]),
          3: parseFloat(sassModule["motion-flash-duration-short-3"]),
          4: parseFloat(sassModule["motion-flash-duration-short-4"])
        },
        medium: {
          1: parseFloat(sassModule["motion-flash-duration-medium-1"]),
          2: parseFloat(sassModule["motion-flash-duration-medium-2"]),
          3: parseFloat(sassModule["motion-flash-duration-medium-3"]),
          4: parseFloat(sassModule["motion-flash-duration-medium-4"])
        },
        long: {
          1: parseFloat(sassModule["motion-flash-duration-long-1"]),
          2: parseFloat(sassModule["motion-flash-duration-long-2"]),
          3: parseFloat(sassModule["motion-flash-duration-long-3"]),
          4: parseFloat(sassModule["motion-flash-duration-long-4"])
        },
        extra_long: {
          1: parseFloat(sassModule["motion-flash-duration-extra_long-1"]),
          2: parseFloat(sassModule["motion-flash-duration-extra_long-2"]),
          3: parseFloat(sassModule["motion-flash-duration-extra_long-3"]),
          4: parseFloat(sassModule["motion-flash-duration-extra_long-4"])
        }
      }
    }
  }
};
export {
  sass
};
//# sourceMappingURL=sass.js.map
